export default __webpack_public_path__ + "static/media/magic-link.13894de8.svg";